import styled from 'styled-components';
import { useModal } from './useModal';

interface Props {
  nick: string; // nick del jugador en el server ('' = no se encontró jugador para esa identidad)
  onConfirm: () => void;
  onCancel: () => void;
}

// Modal de confirmación de restauración de identidad. Se muestra DESPUÉS de computar la identidad del
// respaldo (sin adoptarla todavía): el usuario ve en quién va a entrar y acepta o cancela.
export function RestoreConfirm({ nick, onConfirm, onCancel }: Props) {
  const panelRef = useModal(onCancel);
  return (
    <Overlay onClick={onCancel}>
      <Card ref={panelRef} role="dialog" aria-modal="true" aria-label="Restaurar identidad" tabIndex={-1} onClick={(e) => e.stopPropagation()}>
        <h3>Restaurar identidad</h3>
        {nick ? (
          <p>
            Vas a entrar como <strong>«{nick}»</strong>. Los pronósticos y torneos de esa cuenta van a
            aparecer en este dispositivo.
          </p>
        ) : (
          <p className="warn">
            ⚠️ No encontramos ningún jugador de la Timba con esa identidad. Revisá tus 24 palabras, o
            restaurala igual si esa cuenta todavía no jugó.
          </p>
        )}
        <div className="row">
          <button type="button" className="ghost" onClick={onCancel}>
            Cancelar
          </button>
          <button type="button" className="primary" onClick={onConfirm}>
            {nick ? 'Confirmar' : 'Restaurar igual'}
          </button>
        </div>
      </Card>
    </Overlay>
  );
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.62);
  backdrop-filter: blur(2px);
`;

const Card = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.text};
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.radius};
  padding: 22px 20px 18px;
  text-align: center;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.45);

  h3 {
    margin: 0 0 10px;
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.accentInk};
  }
  p {
    margin: 0 0 18px;
    font-size: 0.95rem;
    line-height: 1.5;
  }
  p strong {
    color: ${({ theme }) => theme.colors.text};
  }
  p.warn {
    color: #f0a020;
  }
  .row {
    display: flex;
    gap: 10px;
  }
  .row button {
    flex: 1;
    border-radius: 999px;
    padding: 11px;
    font-weight: 700;
    font-size: 0.92rem;
  }
  .row .ghost {
    background: transparent;
    border: 1px solid ${({ theme }) => theme.colors.borderStrong};
    color: ${({ theme }) => theme.colors.text};
  }
  .row .primary {
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.accentText};
    border: none;
  }
`;
